import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=5c9b0f3e"
import script from "./SortIcon.vue?vue&type=script&lang=js"
export * from "./SortIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports